import { render, staticRenderFns } from "./SettingsInvoiceItems.vue?vue&type=template&id=326cfe7e"
import script from "./SettingsInvoiceItems.vue?vue&type=script&lang=js"
export * from "./SettingsInvoiceItems.vue?vue&type=script&lang=js"
import style0 from "./SettingsInvoiceItems.vue?vue&type=style&index=0&id=326cfe7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports